// extracted by mini-css-extract-plugin
module.exports = {"hero":"LoginModalHeader_hero__GCJ7Z","default":"LoginModalHeader_default__zO5_C","closeButton":"LoginModalHeader_closeButton__MppeK"};